import React, { useState, useEffect } from "react";
import Cards from 'react-bootstrap/Card';
import PhotoSlider from "./PhotoSlider";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CardStandard = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleCardClick = () => {

        if (isExperience) {
            navigate(`/experiences/${props?.card?.category}/${props?.card?.seoInformation.linkUrl}`);

        } else {
            navigate("/property-collection/" + props?.card?.seoInformation.linkUrl.toLowerCase().replace(/\s+/g, '-'));
        }
    };

    const [isLaptopTabletMobile, setIsLaptopTableMobile] = useState(window.matchMedia("screen and (max-width: 1600px)").matches);

    useEffect(() => {
        const handleResize = () => setIsLaptopTableMobile(window.matchMedia("screen and (max-width: 1450px)").matches);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const image = (props?.card?.category === "villa" || props?.card?.category === "apartment") ? (props?.card?.gallery ?? []) : (props?.card?.heading?.image ?? "")

    const isCarousel = Array.isArray(image) ? image.length > 1 ? true : false : false;

    const isExperience = (props?.card?.category === "villa" || props?.card?.category === "apartment") ? false : true;

    return (
        <Cards className="card-property-collection rounded-0 cursor mb-5" >
            <div>
                {isCarousel ? (
                    <PhotoSlider
                        slides={image.length < 9 ? image.slice(0, image.length) : image.slice(0, 10)}
                        onClick={() => handleCardClick()}
                    />
                ) : (

                    <Cards.Img
                        onClick={() => handleCardClick()}
                        variant="top"
                        src={process.env.REACT_APP_SITE_URL + (image && (image[0]?.objectUrl ?? ""))}
                    />
                )
                }
            </div>

            <Cards.Body onClick={() => handleCardClick()} className="card-standard-body">
                <Cards.Text>
                    <div className="d-flex justify-content-start pt-2 card-text">
                        <div>
                            <p className="paragraph text-uppercase pe-2 info-card">
                                {!isExperience ? (props?.card?.address?.area ?? "") : (props?.card?.category.replace("-", " ") ?? "")}
                            </p>
                        </div>
                    </div>
                </Cards.Text>


                <div className="text-left">
                    <h2 className="sub-title text-uppercase">{!isExperience ? (props?.card?.name ?? "") : (props?.card?.title ?? "")}</h2>
                </div>

                {isExperience ? (
                    <Cards.Text>
                        <div className="d-flex justify-content-start pt-2 card-text">
                            <div>
                                <p className="paragraph text-uppercase pe-2 info-card">
                                    {props?.card?.shortDescription ?? ""}
                                </p>
                            </div>
                        </div>
                    </Cards.Text>
                ) :
                    (
                        <>
                            <Cards.Text>
                                <div className="d-flex justify-content-start pt-2 card-text">
                                    <div>
                                        <p className="paragraph border-end border-1 border-dark text-uppercase pe-2 info-card">
                                            {props?.card?.guests ?? 0} {t('Guests')}
                                        </p>
                                    </div>
                                    {!isLaptopTabletMobile && (
                                        <div>
                                            <p className="paragraph border-end border-1 border-dark text-uppercase px-2 info-card">
                                                {props?.card?.bedrooms ?? 0} {t('Bedrooms')}
                                            </p>
                                        </div>

                                    )}

                                    <div>
                                        <p className="paragraph border-end border-1 border-dark text-uppercase px-2 info-card">
                                            {props?.card?.beds ?? 0} {t('Beds')}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="paragraph text-uppercase px-2 info-card">
                                            {props?.card?.bathrooms ?? 0} {t('Bathrooms')}
                                        </p>
                                    </div>
                                </div>

                            </Cards.Text>
                            <Cards.Subtitle>
                                {props?.card?.category ?? ""}
                            </Cards.Subtitle>
                        </>
                    )
                }

            </Cards.Body>
        </Cards>
    );
};

export default CardStandard;